import { GridSortModel } from '@mui/x-data-grid-pro';
import { SorterSet } from '../types/gql-types';

export class SorterMapper {
  mapSorters(sorters: GridSortModel, nameMap: Map<string, string>): SorterSet[] {
    return sorters.map(({ field, sort }) => ({
      field: this.mapFieldName(field, nameMap),
      order: (sort || 'asc').toUpperCase(),
    }));
  }

  private mapFieldName(name: string, nameMap: Map<string, string>): string {
    if (nameMap.has(name)) {
      return nameMap.get(name) as string;
    }

    return name;
  }
}
